import { IComponentProps } from "@cd2/tools/build/es6"
import React from "react"
import { QuickToolTip } from "./QuickTooltip"

export function QuickToolTipWrapper({
  content,
  children,
  showToolTip,
  toolTipProps,
}: {
  content: React.ReactNode
  children: React.ReactNode
  showToolTip: boolean
  toolTipProps?: Omit<IComponentProps<typeof QuickToolTip>, "content" | "children">
}) {
  if (!showToolTip) {
    return <React.Fragment>{children}</React.Fragment>
  }
  return (
    <QuickToolTip content={content} {...toolTipProps}>
      {children}
    </QuickToolTip>
  )
}
